import React, { useState } from 'react';
import axios from '../axios';

const SectionLowerBanners = ({ onSelectPlace, prefId }) => {
  const [places, setPlaces] = useState([]);

  React.useEffect(() => {
    axios.get('/api/places', { params: { place_category_id: 11, ...(prefId && { pref_id: prefId })}})
      .then((res) => setPlaces(res.data))
      .catch(() => {});
  }, [prefId]);

  if (!places.length) return null;

  return (
    <div className="container col-md-8 col-lg-6 p-0 mb-2">
      <div className="d-flex overflow-auto">
        {places.map((place) => (
          <div className="place_square-box ml-2 mt-0" key={place.id}
            onClick={() => onSelectPlace && onSelectPlace(place.id)}
            role="button">
            <img
              src={place.image_data_medium || place.image_data || '/assets2019/img/icon_camera.svg'}
              alt={place.name}
              className="place_square-img"
            />
            <span className="place_square-overlay">{place.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionLowerBanners;
